export default "__VITE_ASSET__BHpUy_GA__"